import { useState, useEffect } from 'react'

/**
 * Hook para hacer debounce de un valor.
 * Útil para evitar demasiadas peticiones mientras el usuario escribe.
 *
 * @param value - El valor a hacer debounce
 * @param delay - Tiempo de espera en ms (default: 300ms)
 * @returns El valor con debounce aplicado
 */
export function useDebounce<T>(value: T, delay: number = 300): T {
  const [debouncedValue, setDebouncedValue] = useState<T>(value)

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedValue(value)
    }, delay)

    return () => {
      clearTimeout(timer)
    }
  }, [value, delay])

  return debouncedValue
}
